import { render, staticRenderFns } from "./resource-management.vue?vue&type=template&id=e4597e26&scoped=true"
import script from "./resource-management.vue?vue&type=script&lang=js"
export * from "./resource-management.vue?vue&type=script&lang=js"
import style0 from "./resource-management.vue?vue&type=style&index=0&id=e4597e26&prod&scoped=true&lang=scss"
import style1 from "./resource-management.vue?vue&type=style&index=1&id=e4597e26&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e4597e26",
  null
  
)

export default component.exports